import React from 'react';
import './Home.css';
import Picture from '../../components/homePic/Picture';
import HomeIntro from '../../components/homeIntro/HomeIntro';
import sleep from '../../utils/sleep';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.bgAnimation = React.createRef();
  }

  drawLogoInConsole() {
    console.clear();
    console.log(""
      +"\n                        ,@/\\@`"
      +"\n                        =^   @^"
      +"\n                            @ "
      +"\n                        ]*..=^.,/@@@]`"
      +"\n                 ,/@/[`    ,`.          [@\\` "
      +"\n               /@[                      [@`"
      +"\n             @/                           \\@"
      +"\n             =@`                              ,@`"
      +"\n            //     `    .=@`    ,]           ,@^"
      +"\n           //    ./^...`]@@`    ,@\\^.O@        .,@^"
      +"\n          //    .=/.../@`=@    =@.=@=^\\\\..=^    @^"
      +"\n          .@`    =@^.=@/..=@...=@...@@/[\\\\.@O*..`@^"
      +"\n         =@^...,@@^=@    .@`..@`    \\@..\\@=^..@@^"
      +"\n         =@^...@^=@@*    .=@`//            \\@@.,@@ "
      +"\n         \\@..=@..\\^        .\\@`*            .@`=@/"
      +"\n         ,@@^.@^...,@@@                /@`...@^@/\\@\\`"
      +"\n         @^,@/@    =@@@^            ..@@@@^..,@@..//"
      +"\n         @^.*@@    .,/    .*...*    ..[[`...=@^\\@/ "
      +"\n          ,\\@\\@^..,O`,O`.,O`,O`,O`.,/`,/    @@@/* "
      +"\n            ..@^.,[.=/.,o`,o`,o`*//*//    .=@ "
      +"\n            ..@^    ..o/*=^*/^.=/.*o`    ..@^"
      +"\n            ..,@\\`.@@@@@@@@@@@@@@@@@@@@^../@"
      +"\n                .,[@@@@@@@@@@@@@@@@@@@\\/@["
      +"\n                ,/@@@@@@@@@@@@@@@@@@@@@]"
      +"\n                    ,@/@@@@@@@@@@@@@@@`.*."
      +"\n                ,@`    [@@@@@@@@/`..@\\");
  }

  componentDidMount() {
    this.drawLogoInConsole();

    sleep(200)
    .then(()=> {
      this.bgAnimation.current.style.height="1600px";
    })
  }
  render() {
    return (
      <React.Fragment>
        <div className="mask-animation-container">
          <div className="mask-animation" ref={this.bgAnimation}></div>
        </div>   
        
        <section className="home-content">
          <HomeIntro/>
          <Picture/>
        </section>
      </React.Fragment>     
    )
  }
}

export default Home;